import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-problem',
  imports: [SectionWrapperComponent, MatIconModule],
  templateUrl: './problem.component.html',
  styleUrl: './problem.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProblemComponent {
  private readonly siteConfig = inject(SiteConfigService);

  readonly section = this.siteConfig.problem;
}
